<flx-resources-grid
  [tableDef]="notificationsTableColumns"
  [inputGridOptions]="gridOptions()"
  (gridReady)="onGridReady($event)"
  emptyMsg="No notifications found."
/>
